(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-ks-bf-scroll]').forEach((section) => {
      if (section.dataset.ksBfReady === 'true') return;
      const grid = section.querySelector('[data-products-container]');
      const sentinel = section.querySelector('[data-ks-bf-sentinel]');
      const status = section.querySelector('[data-ks-bf-status]');
      const retry = section.querySelector('[data-ks-bf-retry]');
      const fallback = section.querySelector('[data-ks-bf-fallback]');
      if (!grid || !sentinel || !status || !retry || !('IntersectionObserver' in window)) return;
      section.dataset.ksBfReady = 'true';
      let nextUrl = section.dataset.nextUrl;
      let busy = false;
      let failed = false;
      let controller;
      const seen = new Set(Array.from(grid.querySelectorAll('[data-ks-bf-product]'), (item) => item.dataset.ksBfProduct));
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadNext();
      }, { rootMargin: '300px 0px', threshold: 0 });
      const finish = () => {
        observer.disconnect();
        retry.hidden = true;
        if (fallback) fallback.hidden = true;
        status.textContent = section.dataset.completeLabel;
      };
      const loadNext = async () => {
        if (busy || failed || !nextUrl || !section.isConnected) return;
        busy = true;
        observer.unobserve(sentinel);
        retry.hidden = true;
        if (fallback) fallback.hidden = true;
        grid.setAttribute('aria-busy', 'true');
        status.textContent = section.dataset.loadingLabel;
        controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        try {
          const url = new URL(nextUrl, window.location.href);
          if (url.origin !== window.location.origin) throw new Error('Invalid pagination origin');
          url.searchParams.set('section_id', section.dataset.sectionId);
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Could not load offers');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = Array.from(documentFragment.querySelectorAll('[data-ks-bf-scroll]')).find((node) => node.dataset.sectionId === section.dataset.sectionId);
          const sourceGrid = source && source.querySelector('[data-products-container]');
          if (!sourceGrid) throw new Error('Offers missing from response');
          const items = Array.from(sourceGrid.children).filter((item) => item.dataset.ksBfProduct && !seen.has(item.dataset.ksBfProduct));
          if (!items.length) throw new Error('No new offers returned');
          if (!section.isConnected) return;
          const batch = document.createDocumentFragment();
          items.forEach((item) => {
            seen.add(item.dataset.ksBfProduct);
            batch.appendChild(document.importNode(item, true));
          });
          grid.appendChild(batch);
          nextUrl = source.dataset.nextUrl || '';
          section.dataset.nextUrl = nextUrl;
          status.textContent = '';
          window.MinimogTheme?.Wishlist?.setWishlistButtonsState?.();
          window.MinimogTheme?.CompareProduct?.setCompareButtonsState?.();
          if (typeof window.refreshProductReview === 'function') window.refreshProductReview();
          if (nextUrl) observer.observe(sentinel);
          else finish();
        } catch (error) {
          if (!section.isConnected) return;
          failed = true;
          status.textContent = section.dataset.errorLabel;
          retry.hidden = false;
          if (fallback) fallback.hidden = false;
        } finally {
          clearTimeout(timeout);
          busy = false;
          grid.removeAttribute('aria-busy');
        }
      };
      retry.addEventListener('click', () => { failed = false; loadNext(); });
      if (fallback) fallback.hidden = true;
      if (nextUrl) observer.observe(sentinel);
      else sentinel.hidden = true;
      const sectionWrapper = section.closest('.shopify-section');
      const unload = (event) => {
        if (event.target === sectionWrapper) {
          observer.disconnect();
          controller?.abort();
          document.removeEventListener('shopify:section:unload', unload);
        }
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();